(function($) {
	"use strict";


})(jQuery); // End of use strict
